const path = {
    settings: '/settings',
    customize: '/customizes/without-tickets',
    customize_values: '/customizes/get-value',
}
export { path }